import { IconName } from '@klp/design/Illustrations';
import { theme } from '@klp/design/Theme/theme';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import type { Bruker } from '@klp/user';
export const AppModuleName = '/';

export enum APP_ENUM {
    isAdmin = 'isAdmin',
    isEDAdmin = 'isEDAdmin',
}

export const AppRoutes = {
    moduleRoute: () => generateRoute([AppModuleName]),
    mainPage: () => generateRoute([AppModuleName]),
};

export const AppFullAccess = (_user?: Bruker): boolean => true;

export const AppMenuItems = [
    new SidebarMenuItem({
        route: AppRoutes.mainPage(),
        matchRoute: AppRoutes.moduleRoute(),
        icon: IconName.HOME,
        translation: 'frontPage.frontpage',
        access: AppFullAccess,
    }),
];

export const isMobileScreen = () =>
    window ? window.innerWidth < theme.breakpoints.values.sm : false;
export const isSmallScreen = () =>
    window ? window.innerWidth < theme.breakpoints.values.md : false;
export const isMediumScreen = () =>
    window ? window.innerWidth < theme.breakpoints.values.lg : false;
export const isLargeScreen = () =>
    window ? window.innerWidth >= theme.breakpoints.values.lg : false;
